
import { mapState } from 'vuex'
import { setMetaRobots } from '@/utils/utils'

export default {
  name: 'PrivacyCommon',
  data() {
    return {
    }
  },
  head() {
    return {
      title: this.$t('home.footer.contact') + ' - ' + this.$t('home.title'),
      meta: [
        setMetaRobots(false)
      ]
    }
  },
  computed: {
    ...mapState({
      setting: state => state.setting
    })
  },
  mounted() {
    document.title = this.$t('home.title')
  }
}
